import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';
import _ from 'lodash';
import Toolbar from '@material-ui/core/Toolbar';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { showDialog, hideDialog } from '../../redux/actions/dialogs';
import { setJob } from '../../redux/actions/jobs';
import Dashboard from '../Dashboard';
import AssignResources from '../Jobs/AssignResourcesDialog';
import AssignResourcesToTasks from '../AssignResourcesToTasksDialog';
import { hasPermission } from '../../utils/authenticated';
import { toJS } from '../../utils/helper';

import styles from './styles';
import { isDialogVisibleSelector } from '../../redux/selectors';
import { ASSIGN_RESOURCES_DIALOG, ASSIGN_RESOURCES_TO_TASKS_DIALOG, JOB_DIALOG } from '../../redux/constants/dialogs';
import SchedulingGrid from './SchedulingGrid';
import { fetchJobsRoutine } from '../../redux/routines';

class Scheduling extends Component {

  componentWillMount() {
    this.setState({
      editable: hasPermission(['JobCreator', 'Administrator']),
    });

    this.loadDate(moment().startOf('d'));
  }

  previousDay = () => {
    const date = this.state.currentDate;
    date.subtract(1, 'days');

    this.loadDate(date);
  };

  nextDay = () => {
    const date = this.state.currentDate;
    date.add(1, 'days');

    this.loadDate(date);
  };

  loadDate = (date) => {
    this.setState({
      currentDate: date,
    });
    this.props.fetchJobs({ date });
  }

  openDatePicker = () => {
    this.dp.openDialog();
  };

  handleAssignResources = (job) => {
    // this.props.setJob(job);
    this.props.showDialog(ASSIGN_RESOURCES_DIALOG, {
      job,
      currentDate: this.state.currentDate,
    });
  };

  handleDateSelected = (x, date) => {
    this.setState({
      currentDate: moment(date),
    });
  };

  render() {
    const { isDialogVisible, jobs, fetchJobs, showDialog } = this.props;
    const { currentDate } = this.state;

    return (
      <Dashboard title="Scheduling">
        <AppBar position="static" color="primary">
          <Toolbar>
            <IconButton
              tooltip="Previous Day"
              onClick={this.previousDay}
              color="inherit"
            >
              <ChevronLeftIcon/>
            </IconButton>

            <span
              style={styles.title}
              onClick={this.openDatePicker}>{currentDate.format('ll')}</span>

            <IconButton
              tooltip="Next Day"
              onClick={this.nextDay}
              color="inherit"
            >
              <ChevronRightIcon/>
            </IconButton>
          </Toolbar>
        </AppBar>
        {/*<DatePicker*/}
        {/*ref={(dp) => this.dp = dp}*/}
        {/*autoOk*/}
        {/*style={styles.datePicker}*/}
        {/*onChange={this.handleDateSelected}/>*/}
        <div style={styles.tableContainer}>
          <SchedulingGrid
            data={jobs}
            fetch={(params) => fetchJobs(_.assign(params, { date: this.state.currentDate }))}
            date={this.state.currentDate}
            onEditJob={(job) => showDialog(JOB_DIALOG, { job })}
            onAssignResources={this.handleAssignResources}
            showDialog={showDialog}
          />
        </div>
        {isDialogVisible(ASSIGN_RESOURCES_DIALOG) ? <AssignResources/> : null}
        {isDialogVisible(ASSIGN_RESOURCES_TO_TASKS_DIALOG) ? <AssignResourcesToTasks/> : null}
      </Dashboard>
    );
  }
}

Scheduling.propTypes = {
  fetchJobs: PropTypes.func.isRequired,
  setJob: PropTypes.func.isRequired,
  jobs: PropTypes.object,
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    jobs: toJS(state.getIn(['jobs', 'jobs'])),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJobs: fetchJobsRoutine.trigger,
    setJob,

    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Scheduling);



// WEBPACK FOOTER //
// ./src/components/Scheduling/index.js